import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUserFlags } from '~/hooks';

const MOBILE_KEY = 'isMobileApp';

export const MobileDetector = () => {
    const { getFlag, setFlag } = useUserFlags();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const isMobile = searchParams.get('mobile') === 'true';
        if (isMobile && getFlag(MOBILE_KEY) !== true) {
            setFlag({ [MOBILE_KEY]: true });
        }
    }, [searchParams]);

    return null;
};
